/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from "react";
import { Form, FormGroup, Label, ListGroup, ListGroupItem, Spinner, Row, Col } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes from "prop-types";

import { ArchiveTypes } from "../../Account/types";
import ModalArchive from "../../Modal/ModalArchive";
import ModalConfirm from "../../Modal/ModalConfirm";
import { PersonType } from "../types";
import { getLocalDate } from "../../../../utils";
import { FormattedDate } from "react-intl";

const ContractsTab = ({ person, archives, setPersonData, archivesTypes, services, onboarding, refresh }) => {
  if (!archives || !archivesTypes) {
    return <Spinner />;
  }
  const getFile = (file) => {
    const body = {
      personId: person.PersonId,
      fileId: file.PersonArchiveId,
    };
    services.fetchPersonFile(body, (response) => {
      var a = document.createElement("A");
      a.href = `data:application/octet-stream;base64,${response.blobfile}`;
      a.download = `${file.PersonArchivesName}.${file.PersonArchivesExtension}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  };

  const getOnboardingFile = (file) => {
    const body = {
      personid: person.PersonId,
      fileid: file.PersonArchiveId,
      onboarding: onboarding,
    };
    services.fetchOnboardingPersonFile(body, (response) => {
      var a = document.createElement("A");
      a.href = `data:application/octet-stream;base64,${response.blobfile}`;
      a.download = `${file.PersonArchivesName}.${file.PersonArchivesExtension}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  };

  return (
    <div>
      <Form>
        <FormGroup tag="fieldset">
          <ListGroup>
            {archives.map((d, i) => (
              <ListGroupItem key={d.PersonArchiveId}>
                <Label>
                  <span style={{ fontSize: "15px", fontWeight: 500 }}>
                    {d.PersonArchivesSubTypeDescription}
                    {":   "}
                  </span>
                  <i className={d.PersonArchivesExtension === "pdf" ? "fa fa-file-pdf-o" : "fa fa-file"} />
                  {!onboarding ? (
                    <a onClick={() => getFile(d)} style={{ cursor: "pointer" }}>
                      {" "}
                      {d.PersonArchivesName}
                    </a>
                  ) : (
                    <a onClick={() => getOnboardingFile(d)} style={{ cursor: "pointer" }}>
                      {" "}
                      {d.PersonArchivesName}
                    </a>
                  )}

                  {d.PersonArchivesHasExpirationDate ? (
                    <Row>
                      <Col>
                        <span style={{ fontSize: "15px", fontWeight: 500 }}>
                          {"Accepted Date: "}
                          <FormattedDate
                            value={
                              d.PersonArchivesExpirationDate.indexOf("T") > -1
                                ? d.PersonArchivesExpirationDate
                                : d.PersonArchivesExpirationDate + "T00:00"
                            }
                          />
                        </span>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col>
                        <span style={{ fontSize: "15px", fontWeight: 500 }}>
                          {"LifeLong: "}
                          {"Yes"}
                        </span>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <span style={{ fontSize: "15px", fontWeight: 500 }}>
                        {"Enabled: "}
                        {d.PersonArchivesEnabled ? "Yes" : "No"}
                      </span>
                    </Col>
                  </Row>
                </Label>
              </ListGroupItem>
            ))}
          </ListGroup>
        </FormGroup>
      </Form>
    </div>
  );
};

ContractsTab.propTypes = {
  person: PropTypes.object.isRequired,
  services: PropTypes.object.isRequired,
  setPersonData: PropTypes.func.isRequired,
  archivesTypes: PropTypes.object,
  archives: PropTypes.array,
};

ContractsTab.defaultProps = {
  archivesTypes: undefined,
  archives: undefined,
};

export default ContractsTab;
